module.exports = __webpack_public_path__ + "img/product_53.0c69adc.webp";